import { IconProps } from '@/components/Icon';

export const IconChevron = ({ width = 16, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 16 16' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path d='M14 5L8 11L2 5' stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' />
    </svg>
  );
};
